export const classes = {
  wrapper: 'w-full flex justify-start items-start pt-6',
  textWrapper: 'place-start flex-col grow',
  orderId: 'font-bold text-2xl text-grey-8 dark:text-mauve-1 mb-1',
  customer: 'font-bold text-xl text-grey-8 dark:text-mauve-1 mb-1',
  externalRef: 'text-lg text-grey-7 dark:text-mauve-2 font-normal mt-2',
  statusWrapper: 'mt-2 mb-2 flex items-center',
  icon: 'text-3xl mx-3 text-grey-7 dark:text-mauve-2 cursor-pointer',
};

export const styles = {
  collapseIcon: (isCollapsed?: boolean) => ({
    transform: `rotateY(${isCollapsed ? '180deg' : '0deg'})`,
    transition: 'transform 0.15s',
  }),
};
